export default __webpack_public_path__ + "static/media/track.6ca4a379.png";